import React, { useEffect, useState } from "react";
import { useSidebarContext } from "../../Context/SidebarManagementContext";
import { Dashboard } from "@mui/icons-material";
import GraphSidebar from "./GraphSidebar";
import SettingContent from "./SettingContent";
import EquipmentGrpSideBar from "./EquipmentGrpSideBar";

export default function SideBarContent({
  equipmentGrpResponse,
  onItemSelected,
}) {
  const { sidebarContentIsSetting } = useSidebarContext();
  const [renderItem, setRenderItem] = useState(null);

  useEffect(() => {
    if (equipmentGrpResponse?.response) {
      switch (sidebarContentIsSetting) {
        case "dashboard":
          setRenderItem(
            <GraphSidebar equipmentGrpResponse={equipmentGrpResponse} />
          );
          break;
        case "setting":
          setRenderItem(
            <SettingContent
              contentSettingAccordion={0}
              setContentSettingAccordion={() => {}}
            />
          );
          break;
        case "equipmentGrpEqiupment":
          setRenderItem(
            <EquipmentGrpSideBar
              onItemSelected={onItemSelected}
              equipmentGrpResponse={equipmentGrpResponse}
            />
          );
          break;
        default:
          setRenderItem(null);
          break;
      }
    }
  }, [equipmentGrpResponse, sidebarContentIsSetting]);

  return <> {renderItem} </>;
}
